import Choices from "choices.js";

class Form_control {
  constructor() {
    this.select = document.querySelectorAll(".select2");

    if (this.select) {
      this.initSelect();
    }
  }

  initSelect() {
    this.select.forEach((sel) => {
      new Choices(sel, {
        shouldSort: false,
        allowHTML: true,
        editItems: true,
        maxItemCount: 5,
        shouldSort: false,
        removeItems: true,
        removeItemButtonAlignLeft: false,
        removeItemButton: true,
        searchEnabled: true,
        searchPlaceholderValue: "Cerca...",
        noChoicesText: "Nessuna opzione disponibile",
        noResultsText: "Nessun risultato trovato",
        itemSelectText: "",
      });
    });
  }
}

export default Form_control;
